import { useId, type ReactNode } from 'react';
type Props = {
  checked: boolean;
  onChange: () => void;
  label: ReactNode;
  hint?: ReactNode;
  className?: string;
  disabled?: boolean;
  /** Extra uitleg buiten de knop (bijv. met een link erin): id van dat element. */
  describedBy?: string;
};

/** Aan/uit-schakelaar met label; de hele regel is aanklikbaar. De uitleg wordt apart voorgelezen. */
export function Switch({
  checked,
  onChange,
  label,
  hint,
  className = '',
  disabled = false,
  describedBy
}: Props) {
  const labelId = useId();
  const hintId = useId();
  const described = [hint ? hintId : null, describedBy ?? null].filter(Boolean).join(' ') || undefined;
  return <button type="button" role="switch" aria-checked={checked === true} aria-labelledby={labelId} aria-describedby={described} disabled={disabled} onClick={onChange} className={`group flex w-full items-start gap-4 text-left disabled:cursor-not-allowed disabled:opacity-60 ${className}`} data-id="element-6845" data-mp="2yfei8h3cv1bs">
      <span className="min-w-0 flex-1" data-id="element-6846" data-mp="1ox8s8twjpmeo">
        <span id={labelId} className="block text-[15px] text-ink" data-id="element-6847" data-mp="1ow7kayattg16">
          {label}
        </span>
        {hint && <span id={hintId} className="mt-0.5 block text-[13px] leading-relaxed text-muted" data-id="element-6848" data-mp="1tqleixdr5h49">
            {hint}
          </span>}
      </span>
      <span aria-hidden="true" className={`relative mt-0.5 inline-flex h-6 w-11 shrink-0 rounded-full transition-colors duration-150 ease-soft ${checked ? 'bg-clay' : 'bg-line group-hover:bg-ink/20'}`} data-id="element-6849" data-mp="1kvdrbqij1b1f">
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-150 ease-soft ${checked ? 'translate-x-[22px]' : 'translate-x-0.5'}`} data-id="element-6850" data-mp="2cmtfvq3n97ua" />
      </span>
    </button>;
}